import { gql } from '@apollo/client';
export const SourceFragment = gql`
  fragment ClientSourceFields on Source {
    slug
    url
    imageUrl
    image {
      url
    }
    article
    callToAction
    subtitle
    reviewStatus
    __typename
  }
`;

export const ActivityFragment = gql`
  fragment ClientActivityFields on Activity {
    url
    imageUrl
    image {
      url
    }
    name
    slug
    callToAction
    shortDescription
    reviewStatus
    __typename
  }
`;
